import React from 'react';

import { EHeadingSize } from '@domain/enums/components/EHeading';
import { PagSeguroV4 } from '@profitfy/pakkun-icons';
import { ISideModalGatewayContent } from '@domain/interfaces/dashboard/IntegrationCenter/SideModalContent/ISideModalContent';
import { useOtherGatewayIntegration } from '@helpers/hooks/pages/dashboard/integrationCenter/gateway/useOtherGatewayIntegration';
import { useTheme } from 'styled-components';

import IntegrateForm from '@components/Dashboard/IntegrationCenter/SideModalContent/Gateway/OtherGateway/IntegrateForm';
import SkeletonLoading from './SkeletonLoading';

import * as S from './styles';

const Pagseguro: React.FC<ISideModalGatewayContent> = ({
  isFeedSideModal,
  syncOnCreate,
  toggle,
}) => {
  const theme = useTheme();

  const { isLoadingOtherGateways, otherGateways } = useOtherGatewayIntegration();

  if (isLoadingOtherGateways || Boolean(!otherGateways)) {
    return <SkeletonLoading />;
  }

  return (
    <S.Wrapper>
      <S.HeadingWrapper>
        <PagSeguroV4 size={52} color={theme.colors.green.default} />
        <S.Heading type={EHeadingSize.H4}>Integração com Pagseguro V4</S.Heading>
      </S.HeadingWrapper>

      <IntegrateForm
        gatewayName="Pagseguro v4"
        gatewayId="pagseguro_v4"
        isFeedSideModal={isFeedSideModal}
        syncOnCreate={syncOnCreate}
        toggle={toggle}
      />
    </S.Wrapper>
  );
};

export default Pagseguro;
